import { Injectable } from '@angular/core';
import { EnvironmentConfig } from './environment-config';

// Kommt aus index.html. Könnte man mal noch typisieren...
// eslint-disable-next-line no-var
declare var environmentConfig: any;

/**
 * Service um die richtige Basis-URL für das Backend zu ermitteln.
 */
@Injectable()
export class BackendLocatorService {

    constructor(private envConfig: EnvironmentConfig) {
    }

    /** Ermittelt die Basis-URL für einen bestimmten Service.
     *  Im Produktivmodus ist das immer '/serviceName', also z.B. /user für den User-Service.
     */
    getBaseUrl(serviceName: string): string {
        if(this.envConfig.gatewayUrl) {
            // Frontend läuft unter anderer Domain wie das Backend. Daher wurde die URL des Gateways ecplizit angegeben.
            return `${this.envConfig.gatewayUrl}/${serviceName}`;
        } else {
            // In der Regel läuft das Backend unter der gleichen Domain wie das Frontend
            return `/${serviceName}`;
        }
    }

    /**
     * Alle absoluten URIs werden so interpretiert, dass das erste Pfad-Segment der Service-Name ist.
     */
    replaceUrl(url: string): string {
        if (url && url.startsWith('/')) {
            const serviceNameEnd = url.indexOf('/', 1);
            if (serviceNameEnd === -1 || serviceNameEnd === 1) {
                throw new Error('URL muss mit /{serviceName}/ beginnen: ' + url);
            }
            return this.getBaseUrl(url.substring(1, serviceNameEnd)) + url.substring(serviceNameEnd);
        } else {
            // Der Fall könnte auch noch vorkommen... Z.B. komplette URL des OAuth-Servers
            return url;
        }
    }
}
